import { makeStyles } from '@material-ui/core/styles';
export const changePasswordPageStyle = makeStyles((theme) => ({
    logo: {
        width: '8em'
    },
    dropdown: {
        whiteSpace: 'pre-wrap'
    },
}));
